/**
 * limenda-tutus Premium Homepage — lightweight interactions
 */
(function () {
  'use strict';

  const SELECTORS = {
    carousel: '[data-l-carousel]',
    hero: '[data-l-hero]',
    seoToggle: '[data-l-seo-toggle]',
    header: '[data-l-header]',
    drawer: '[data-l-drawer]',
    footerToggle: '[data-l-footer-toggle]',
    navItem: '[data-l-nav-item]',
    toast: '[data-l-cart-toast]',
  };

  window.LimendaTutus = window.LimendaTutus || {};
  window.LimendaTutus.initScope = initScope;

  window.LimendaTutus.updateHeaderCartCount = function (count) {
    const bubble = document.getElementById('l-header-cart-count');
    if (!bubble) return;
    bubble.dataset.value = String(count);
    let span = bubble.querySelector('span[aria-hidden="true"]');
    if (count > 0) {
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        bubble.appendChild(span);
      }
      span.textContent = count < 100 ? String(count) : '99+';
    } else if (span) {
      span.remove();
    }
    document.querySelectorAll('.l-header__action--cart .count_item, #cart-icon-bubble.count_item').forEach(function (el) {
      el.remove();
    });
  };

  function patchEurusCartUi() {
    document.addEventListener('alpine:init', function () {
      if (!window.Alpine?.store) return;
      const miniCart = Alpine.store('xMiniCart');
      if (miniCart && !miniCart._limendaPatched) {
        miniCart._limendaPatched = true;
        miniCart.openCart = function () {
          if (typeof window.LimendaTutus.showCartToast === 'function') {
            window.LimendaTutus.showCartToast();
          }
        };
        miniCart.show = false;
        miniCart.open = false;
      }
      const cartNoti = Alpine.store('xCartNoti');
      if (cartNoti && !cartNoti._limendaPatched) {
        cartNoti._limendaPatched = true;
        const originalSetItem = cartNoti.setItem?.bind(cartNoti);
        cartNoti.setItem = function (item) {
          if (typeof window.LimendaTutus.showCartToast === 'function') {
            window.LimendaTutus.showCartToast();
            if (item?.quantity && typeof window.LimendaTutus.updateHeaderCartCount === 'function') {
              fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  window.LimendaTutus.updateHeaderCartCount(cart.item_count);
                })
                .catch(function () {});
            }
            return;
          }
          if (originalSetItem) originalSetItem(item);
        };
        cartNoti.show = false;
      }
    }, { once: true });
  }

  /* ── Cart toast ── */
  let toastTimer;
  window.LimendaTutus.showCartToast = function () {
    const toast = document.querySelector(SELECTORS.toast);
    if (!toast) return;
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 6000);
  };

  function initCartToast() {
    const toast = document.querySelector(SELECTORS.toast);
    if (!toast || toast.dataset.lInit) return;
    toast.dataset.lInit = '1';
    toast.querySelector('[data-l-toast-close]')?.addEventListener('click', function () {
      toast.classList.remove('is-visible');
    });
  }

  /* ── Generic horizontal carousel ── */
  function initCarousel(el) {
    if (el.dataset.lInit) return;
    el.dataset.lInit = '1';
    const track = el.querySelector('[data-l-carousel-track]');
    const prev = el.querySelector('[data-l-carousel-prev]');
    const next = el.querySelector('[data-l-carousel-next]');
    if (!track) return;

    const scrollStep = function (dir) {
      const amount = track.clientWidth * 0.85;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', function () { scrollStep(-1); });
    next?.addEventListener('click', function () { scrollStep(1); });

    prev?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollStep(-1); }
    });
    next?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollStep(1); }
    });
  }

  /* ── Hero slider ── */
  function initHero(el) {
    if (el.dataset.lInit) return;
    el.dataset.lInit = '1';
    const slides = el.querySelectorAll('[data-l-hero-slide]');
    const dots = el.querySelectorAll('[data-l-hero-dot]');
    const prev = el.querySelector('[data-l-hero-prev]');
    const next = el.querySelector('[data-l-hero-next]');
    const counter = el.querySelector('[data-l-hero-counter]');
    if (slides.length <= 1 && !prev && !next) return;

    let current = 0;
    let timer;
    const autoplay = el.dataset.autoplay === 'true';
    const interval = parseInt(el.dataset.interval || '6000', 10);

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        const isActive = i === current;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.querySelectorAll('video').forEach(function (video) {
          if (isActive) {
            video.play().catch(function () {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    prev?.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    next?.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    goTo(0);
    startAutoplay();
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', startAutoplay);
  }

  /* ── SEO toggle ── */
  function initSeoToggle(el) {
    if (el.dataset.lInit) return;
    el.dataset.lInit = '1';
    const body = el.closest('.l-seo-content')?.querySelector('[data-l-seo-body]');
    const labelShow = el.dataset.labelShow || 'Mehr anzeigen';
    const labelHide = el.dataset.labelHide || 'Weniger anzeigen';
    if (!body) return;

    el.addEventListener('click', function () {
      const expanded = body.classList.toggle('is-collapsed') === false;
      el.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      el.textContent = expanded ? labelHide : labelShow;
    });
  }

  /* ── Sticky header shadow ── */
  function initHeader(el) {
    if (el.dataset.lInit) return;
    el.dataset.lInit = '1';
    const onScroll = function () {
      el.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile drawer ── */
  function initDrawer(root) {
    if (root.dataset.lInit) return;
    root.dataset.lInit = '1';
    const openBtns = document.querySelectorAll('[data-l-drawer-open]');
    const closeBtns = root.querySelectorAll('[data-l-drawer-close]');
    const overlay = root.querySelector('[data-l-drawer-overlay]');
    const panel = root.querySelector('.l-drawer__panel');
    const backBtn = root.querySelector('[data-l-drawer-back]');
    const mainPanel = root.querySelector('[data-l-drawer-main]');
    const subPanels = root.querySelectorAll('[data-l-drawer-sub]');

    function openDrawer() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      panel?.focus();
    }

    function closeDrawer() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      showMain();
    }

    function showMain() {
      mainPanel?.removeAttribute('hidden');
      subPanels.forEach(function (p) { p.setAttribute('hidden', ''); });
      backBtn?.setAttribute('hidden', '');
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    overlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });

    root.querySelectorAll('[data-l-drawer-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const targetId = trigger.dataset.lDrawerTarget;
        const sub = root.querySelector('#' + targetId);
        if (!sub) return;
        mainPanel?.setAttribute('hidden', '');
        subPanels.forEach(function (p) { p.setAttribute('hidden', ''); });
        sub.removeAttribute('hidden');
        backBtn?.removeAttribute('hidden');
      });
    });

    backBtn?.addEventListener('click', showMain);
  }

  /* ── Mega menu (desktop) ── */
  function initMegaMenu() {
    document.querySelectorAll(SELECTORS.navItem).forEach(function (item) {
      if (item.dataset.lInit) return;
      item.dataset.lInit = '1';
      const hasMega = item.querySelector('.l-header__megamenu');
      if (!hasMega) return;

      let closeTimer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 150);
      });
      item.addEventListener('focusin', function () { item.classList.add('is-open'); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
  }

  /* ── Footer accordion (mobile) ── */
  function initFooterToggles() {
    document.querySelectorAll(SELECTORS.footerToggle).forEach(function (btn) {
      if (btn.dataset.lInit) return;
      btn.dataset.lInit = '1';
      btn.addEventListener('click', function () {
        const col = btn.closest('.l-footer__column');
        if (!col || window.innerWidth >= 990) return;
        col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
      });
    });
  }

  /* ── Splide product/review carousels ── */
  function loadSplideScript(callback) {
    if (typeof Splide !== 'undefined') {
      callback();
      return;
    }
    if (window.Eurus && window.Eurus.sliderScript) {
      const existing = document.querySelector('script[src*="splide"]');
      if (existing) {
        existing.addEventListener('load', callback, { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = window.Eurus.sliderScript;
      script.defer = true;
      script.addEventListener('load', callback, { once: true });
      document.head.appendChild(script);
      return;
    }
    document.addEventListener('alpine:init', function () {
      setTimeout(callback, 50);
    }, { once: true });
  }

  function initSplideCarousels(scope) {
    scope.querySelectorAll('[data-l-splide]').forEach(function (el) {
      if (el.dataset.lSplideInit) return;

      const mount = function () {
        if (el.dataset.lSplideInit || typeof Splide === 'undefined') return;
        el.dataset.lSplideInit = '1';

        const perPage = parseInt(el.dataset.perPage || '2', 10);
        const perPageMd = parseInt(el.dataset.perPageMd || '3', 10);
        const perPageLg = parseInt(el.dataset.perPageLg || '5', 10);

        const splide = new Splide(el, {
          type: 'slide',
          perPage: perPage,
          gap: '16px',
          pagination: false,
          arrows: true,
          drag: true,
          breakpoints: {
            767: { perPage: perPage },
            989: { perPage: perPageMd },
            1199: { perPage: perPageMd },
            9999: { perPage: perPageLg },
          },
        });

        splide.on('mounted', function () {
          el.querySelectorAll('.splide__arrow').forEach(function (arrow) {
            arrow.innerHTML = arrow.classList.contains('splide__arrow--prev')
              ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>'
              : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>';
          });
        });

        splide.mount();
      };

      loadSplideScript(mount);
    });
  }

  function initScope(scope) {
    scope = scope || document;
    scope.querySelectorAll(SELECTORS.carousel).forEach(initCarousel);
    scope.querySelectorAll(SELECTORS.hero).forEach(initHero);
    scope.querySelectorAll(SELECTORS.seoToggle).forEach(initSeoToggle);
    scope.querySelectorAll(SELECTORS.header).forEach(initHeader);
    scope.querySelectorAll(SELECTORS.drawer).forEach(initDrawer);
    initMegaMenu();
    initFooterToggles();
    initCartToast();
    initSplideCarousels(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initScope(); patchEurusCartUi(); });
  } else {
    initScope();
    patchEurusCartUi();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initScope(e.target);
  });

  document.addEventListener('eurus:cart:items-changed', function () {
    /* optional: sync cart count bubbles handled by theme */
  });
})();
